import React from "react";
import { T } from "react-translator-component";
import { Modal, Box, Typography } from "@mui/material";
import SubmitButton from "../../SubmitButton";
import { styles } from "../../../pages/styles";

// Define the props interface
interface MessageModalProps {
  open: boolean;
  message: any;
  onClose: () => void;
  onContinue: () => void;
}

const ConfirmationModal: React.FC<MessageModalProps> = ({ open, onClose, onContinue, message }) => {

  const handleSubmit = async () => {
    try {
      onContinue()
      return true
    } catch {
      return false
    }
  }

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "90%",
          maxWidth: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          alignItems: "center"
        }}
      >
        <Typography variant="body1" sx={{ mb: 2 }}>
          {message}
        </Typography>

        <SubmitButton
          color="secondary"
          size={"large"}
          variant="contained"
          style={{
            ...styles.introSliderBtn,
            margin: "40px auto",
            width: 220,
            display: "flex",
            justifyContent: "space-between"
          }}
          validate={async () => true}
          onSubmit={handleSubmit}
        >
          <span style={{ paddingRight: 20, paddingLeft: 20, width: "100%" }}>
            {T('yes')}
          </span>
        </SubmitButton>

        <Typography sx={{ textAlign: "center" }} onClick={onClose}>
          {T('no')}
        </Typography>
      </Box>
    </Modal>
  );
};

export default ConfirmationModal;
